import { RoomTemplate } from '../types/map.types';

// Rounded 7×7 footprint (1 = ground, 0 = wall). Corners are walls; the cardinal
// edge midpoints (rows/cols 2-4) stay ground so center-to-center corridors
// always attach on ground. Markers sit on the always-ground center rows.
const ROUNDED_7X7: number[][] = [
  [0, 0, 1, 1, 1, 0, 0],
  [0, 1, 1, 1, 1, 1, 0],
  [1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 1, 1, 1, 0],
  [0, 0, 1, 1, 1, 0, 0],
];

// ---------------------------------------------------------------------------
// Vault room: 7×7, vault at center (1×1 at offset (3, 3)).
// ---------------------------------------------------------------------------

export const VAULT_ROOM: RoomTemplate = {
  id: 'vault-room',
  width: 5,
  height: 5,
  locations: [{ locationId: 'vault', x: 2, y: 2 }],
  unique: true,
  mandatory: false,
  padding: 1,
};

// ---------------------------------------------------------------------------
// Challenge room: 7×7.
// challenge-trigger at center-top (3, 2).
// Chest reward is NOT placed at generation — spawned by ChallengeService on
// wave clear at offset (0, +3) from the trigger (absolute: triggerX, triggerY+3).
// ---------------------------------------------------------------------------

export const CHALLENGE_ROOM: RoomTemplate = {
  id: 'challenge-room',
  width: 7,
  height: 7,
  pattern: ROUNDED_7X7,
  locations: [{ locationId: 'challenge-trigger', x: 3, y: 2 }],
  unique: true,
  mandatory: false,
  padding: 1,
};

// ---------------------------------------------------------------------------
// Mini-boss lairs: 7×7, lair location (1×1) centered at offset (3, 3).
// ---------------------------------------------------------------------------

export const LAIR_KITSUNE_ROOM: RoomTemplate = {
  id: 'lair-kitsune-room',
  width: 7,
  height: 7,
  pattern: ROUNDED_7X7,
  locations: [{ locationId: 'lair-kitsune', x: 3, y: 3 }],
  unique: true,
  mandatory: false,
  padding: 1,
};

export const LAIR_JINN_ROOM: RoomTemplate = {
  id: 'lair-jinn-room',
  width: 7,
  height: 7,
  pattern: ROUNDED_7X7,
  locations: [{ locationId: 'lair-jinn', x: 3, y: 3 }],
  unique: true,
  mandatory: false,
  padding: 1,
};

export const LAIR_PARASITE_ROOM: RoomTemplate = {
  id: 'lair-parasite-room',
  width: 7,
  height: 7,
  pattern: ROUNDED_7X7,
  locations: [{ locationId: 'lair-parasite', x: 3, y: 3 }],
  unique: true,
  mandatory: false,
  padding: 1,
};

// ---------------------------------------------------------------------------
// Aggregated lists
// ---------------------------------------------------------------------------

export const ROOM_TEMPLATE_REGISTRY: Record<string, RoomTemplate> =
  Object.fromEntries(
    [
      VAULT_ROOM,
      CHALLENGE_ROOM,
      LAIR_KITSUNE_ROOM,
      LAIR_JINN_ROOM,
      LAIR_PARASITE_ROOM,
    ].map((t) => [t.id, t]),
  );
